// Real network poster for the outbox drain. Injected into drainOutbox() by the
// app; unit tests pass a stub instead. Auth comes from the current operator
// token (the drain — not the offline sale — is what needs a live token, §8.2g).

import { getAccessToken } from "@awtoban/shared";

import type { CommitPayload } from "./db";
import type { SyncResultItem } from "./sync";

export async function postSync(commits: CommitPayload[]): Promise<{ results: SyncResultItem[] }> {
  const token = getAccessToken();
  const resp = await fetch("/api/v1/transactions/sync", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ commits }),
  });
  if (!resp.ok) {
    throw new Error(`sync failed: ${resp.status}`);
  }
  return resp.json() as Promise<{ results: SyncResultItem[] }>;
}
